import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommonCrudService} from "../common/common-crud.service";
import {ToastService} from "../toast-service";
import {CrystalclearEticketBackUrl} from "../config/crystalclear-eticket-back-url";
import {ETicket} from "../../model/eticket/e-ticket";
import {Observable} from "rxjs";
import {ApiValidation} from "../../model/api/api-validation";
import {WebTradeOrderView} from "../../model/internal/web-trade-order-view";
import {CrystalclearInternalBackUrl} from "../config/crystalclear-internal-back-url";

@Injectable({
  providedIn: 'root'
})
export class EticketService extends CommonCrudService<ETicket> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearEticketBackUrl.GET_ETICKET_LIST,
      CrystalclearEticketBackUrl.SAVE_ETICKET,
      CrystalclearEticketBackUrl.DELETE_ETICKET);
  }

  getDesks() {
      return this.post(CrystalclearEticketBackUrl.GET_DESKS);
  }
}
